import { render, staticRenderFns } from "./Gross_copy.vue?vue&type=template&id=a3c1d008"
import script from "./Gross_copy.vue?vue&type=script&lang=js"
export * from "./Gross_copy.vue?vue&type=script&lang=js"
import style0 from "./Gross_copy.vue?vue&type=style&index=0&id=a3c1d008&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports